import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchTaskUsersBranch } from "../../../slices/company/branchUserSlice";
import { createTask, updateTask } from "../../../slices/company/taskSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchTenders } from "../../../slices/company/tenderSlice";


const TaskFormCreate = () => {
    const type = useParams();
    const location = useLocation();
    const initialData = location.state?.initialData || {};
    const permissionData = JSON.parse(localStorage.getItem('permissions')) || [
        "Sales", "Orders", "Stock", "Purchases", "Production", 
        "Return", "Accounts", "Data and Clerical", "Human Resource", "Master Setup"
    ];


    const [formData, setFormData] = useState({
        tender_id: "",
        name: "",
        description: "",
        estimate_hour: "",
        task_for: permissionData && permissionData.length == 1?permissionData[0]:"",
        priority: "Low",
        start_date: "",
        end_date: "",
        task_users: [],
    });


    useEffect(() => {
        if(type.type == 'create'){
            setFormData({
                tender_id: "",
                name: "",
                description: "",
                estimate_hour: "",
                task_for: permissionData && permissionData.length == 1?permissionData[0]:"",
                priority: "Low",
                start_date: "",
                end_date: "",
                task_users: [],
            });
        }
    },[type]);


    useEffect(() => {
        if (type.type == 'edit' && initialData) {
            setFormData((prevData) => ({
                ...prevData,
                tender_id: initialData.id || "",
                name: initialData.name || "",
                description: initialData.description || "",
                estimate_hour: initialData.estimate_hour || "",
                task_for: initialData.task_for || permissionData && permissionData.length == 1?permissionData[0]:"",
                priority: initialData.task_for || "Low",
                start_date: initialData.start_date.split("T")[0] || "",
                end_date: initialData.end_date.split("T")[0] || "",
                task_users: initialData.TaskUsers ? initialData.TaskUsers.map(user => user.user_id) : [],
            }));
        }
    }, [initialData, type]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { branchUsers } = useSelector((state) => state.branchUsers);
    const { tenders } = useSelector(state => state.tenders);

    const toggleUserSelection = (userId) => {
        setFormData((prev) => {
            const isSelected = prev.task_users.includes(userId);
            return {
                ...prev,
                task_users: isSelected
                    ? prev.task_users.filter((id) => id !== userId) // Remove user
                    : [...prev.task_users, userId], // Add user
            };
        });
    };

    


    useEffect(() => {
        // Fetch branches when the component mounts
        dispatch(fetchTaskUsersBranch());
        const company = JSON.parse(localStorage.getItem('company'));
        const companyId = company.company?.id;
        dispatch(fetchTenders({ id: companyId, status: 0 }));
    }, [dispatch]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(formData.task_users.length == 0){
            alert('Please Select Task User');
            return;
        }
        const company = JSON.parse(localStorage.getItem('company'));
        const companyId = company.company?.id;
        const user_id = localStorage.getItem('user_id');
        const dataToSubmit = { ...formData, notes: JSON.stringify(formData.notes), company_id: companyId, created_by: user_id };
        // dispatch(createTask(dataToSubmit));
        // navigate('/task/assigned-by-you');
        try {
            let result;
            if(initialData && initialData.id){
                result = await dispatch(updateTask({id:initialData.id, taskData: dataToSubmit})).unwrap();
            }else{
                result = await dispatch(createTask(dataToSubmit)).unwrap();
            }
            
            if (result) {
                navigate('/task/assigned-by-you'); // Navigate only if task creation is successful
            }
        } catch (error) {
            console.error("Task creation failed:", error);
            alert("Failed to create task. Please try again.");
        }

    };

    const handleUserSelection = (e) => {
        const selectedOptions = Array.from(e.target.selectedOptions, (option) => Number(option.value));
        setFormData({ ...formData, task_users: selectedOptions });
    };

    return (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title">{type.type == 'edit'?"Edit":"Create"} Task</h4>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6">

                                        <div className="form-group">
                                            <label>Task Name</label>
                                            <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <input type="hidden" className="form-control" name="tender_id" value={formData.tender_id} required />
                                        <div className="form-group">
                                            <label>Tender (optional)</label>
                                            <select
                                                className="form-control"
                                                name="tender_id"
                                                value={formData.tender_id}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Option</option>
                                                {tenders && tenders.map((tender, index) => (
                                                    <option key={index} value={tender.id}>
                                                        {tender.tenderId} ({tender.title})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group mt-3">
                                            <label>Description</label>
                                            <textarea className="form-control" name="description" value={formData.description} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group mt-3">
                                            <label>Task Type</label>
                                                <select  className="form-control" name="task_for" value={formData.task_for} onChange={handleChange} required>
                                                    <option value="">Select Option</option>
                                                    {permissionData && permissionData.map((permis, index) => (
                                                        <option key={index} value={permis}>
                                                            {permis}
                                                        </option>
                                                    ))}
                                                </select>
                                            
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group mt-3">
                                            <label>Estimate Hours</label>
                                            <input type="number" className="form-control" name="estimate_hour" value={formData.estimate_hour} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group mt-3">
                                            <label>Priority</label>
                                            <select className="form-control" name="priority" value={formData.priority} onChange={handleChange}>
                                                <option value="Low">Low</option>
                                                <option value="Medium">Medium</option>
                                                <option value="High">High</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group mt-3">
                                            <label>Start Date</label>
                                            <input type="date" className="form-control" name="start_date" value={formData.start_date} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group mt-3">
                                            <label>End Date</label>
                                            <input type="date" className="form-control" name="end_date" value={formData.end_date} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group mt-4">
                                            <label>Assign Users</label>
                                            <div className="user-list">
                                                {branchUsers.map((user) => (
                                                    <div
                                                        key={user.id}
                                                        className={`user-card ${formData.task_users.includes(user.id) ? "selected" : ""}`}
                                                        onClick={() => toggleUserSelection(user.id)}
                                                    >
                                                        <div className="user-info">
                                                            <strong>{user.name}</strong>
                                                            <p>{user.email}</p>
                                                        </div>
                                                        <div className="select-icon">{formData.task_users.includes(user.id) ? "✔" : "+"}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary mt-3">{type.type == 'edit'?"Update":"Create"} Task</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TaskFormCreate;